import { Sheet, SheetContent } from "@/components/ui/sheet";
import { ReportsTrigger } from "../admin/AdminReports";
import { ViewOrEditReportSheetContent } from "./ViewOrEditReportSheetContent";

interface Props {
  isOpen: boolean;
  selectedReport: ReportsTrigger;
  onClose: () => void;
}

export const ViewOrEditReportSheet = ({
  isOpen,
  selectedReport,
  onClose,
}: Props) => {
  return (
    <Sheet open={isOpen}>
      <SheetContent onClose={onClose} className="overflow-auto scrollbar-thin">
        {selectedReport?.report?.id && (
          <ViewOrEditReportSheetContent
            id={selectedReport.report.id}
            isEditModeDefault={selectedReport.isEditModeDefault}
            expenseId={selectedReport?.expense?.id}
            onClose={onClose}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};
